import { supabase } from "@/lib/supabase";
import { QueryData } from "@supabase/supabase-js";
import { queryOptions } from "@tanstack/react-query";
import { IterableElement } from "type-fest";

export type VendorAssessmentLogEntry = IterableElement<QueryData<typeof vendorAssessmentLogQuery>>;

const vendorAssessmentLogQuery = supabase
  .from("Vendor")
  .select("id, name, currency:Currency(id, code), notes, archived, customFieldValues:VendorCustomFieldValue(*)")
  .eq("deleted", false)
  .order("name")
  .throwOnError();

export const vendorAssessmentLogQueryOptions = queryOptions({
  queryKey: ["Vendor", "assessment-log"],
  queryFn: async () => (await vendorAssessmentLogQuery).data,
});
